import axios from "axios";

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'dockerscheduler.codebnb.me/api/v0' : 'http://127.0.0.1:8000/api/v0'
});

instance.defaults.xsrfHeaderName = "X-CSRFToken";

export default instance;


// WEBPACK FOOTER //
// ./src/utils/axios.js